import { createContext, useContext } from "react";
import type { PortalBranding } from "../api/portal";

export const DEFAULT_BRANDING: PortalBranding = {
  logo_url: null,
  logo_dark_url: null,
  primary_color: "#2563eb",
  display_name: "wifi-helpdesk",
  support_email: null,
  support_phone: null,
  welcome_text: null,
  powered_by_visible: true,
  faq_items: null,
  privacy_url: null,
  impressum_url: null,
};

export const BrandingContext = createContext<PortalBranding>(DEFAULT_BRANDING);

export function useBranding(): PortalBranding {
  return useContext(BrandingContext);
}
